import React, {useEffect} from 'react';
import './Kegiatan.css';
import hovFootball from '../../assets/image/hover-football.png';
import hovHiking from '../../assets/image/hover-hiking.png';
import hovTrash from '../../assets/image/hover-trash.png';
import hovKatar from '../../assets/image/hov-katar.png';
import hovPray from '../../assets/image/hov-pray.png';
import AOS from "aos";
import "aos/dist/aos.css";

const Kegiatan = () => {
  useEffect(() =>{
    AOS.init({
      duration: 1000,
      easing: "ease",
    });
  }, []);
  return (
    <>
      <div className='container-kegiatan flex justify-center items-center flex-col'>
        <p className='title-kegiatan' data-aos='fade-up'>
          Kegiatan Kami
        </p>
        <div className='box-kegiatan'>
          <div className='gap-content'>
            <p className='header-kegiatana' data-aos='fade-right'>
              sepak bola
            </p>
            <img src={hovFootball} alt='' srcset='' />
          </div>
          <div className='gap-content'>
            <p className='header-kegiatana' data-aos='fade-right'>
              naik gunung
            </p>
            <img src={hovHiking} alt='' srcset='' />
          </div>
          <div className='gap-content'>
            <p className='header-kegiatana' data-aos='fade-left'>
              Jumaat Bersih
            </p>
            <img src={hovTrash} alt='' srcset='' />
          </div>
          <div className='gap-content'>
            <p className='header-kegiatana' data-aos='fade-left'>
              Tadarus
            </p>
            <img src={hovPray} alt='' srcset='' />
          </div>
          <div className='gap-content'>
            <p className='header-kegiatana' data-aos='fade-right'>
              katar
            </p>
            <img src={hovKatar} alt='' srcset='' />
          </div>
          <div className='gap-content'>
            <p className='header-kegiatana'>　　　</p>
          </div>
          <div className='gap-content'>
            <p className='header-kegiatana'>　　　</p>
          </div>
          <div className='gap-content'>
            <p className='header-kegiatana'>　　　</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Kegiatan
